import { Badge, Button, useTheme } from "@mui/material";
import { MessageCircle } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	unreadCount: number;
	onClick: () => void;
};

export const AdvisorMessagesButton: FC<Props> = ({ unreadCount, onClick }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Badge
			variant="button"
			color="error"
			badgeContent={unreadCount}
			max={99}
			invisible={unreadCount === 0}
		>
			<Button
				variant="tertiary"
				fullWidth
				startIcon={<MessageCircle size={theme.iconSize.sm} />}
				onClick={onClick}
			>
				{t(Resources.Advisor.messages)}
			</Button>
		</Badge>
	);
};
